/* eslint-disable camelcase */
import React from 'react';
import {MaterialReactTable} from 'material-react-table';
import Moment from 'react-moment';
import PrinterType from './printerType';
import {Badge} from 'react-bootstrap';

interface Printer {
  id: number;
  printer_serial_no: string;
  printer_type: string;
  installation_date: string;
  guarantee_state: number;
}

interface PrintersTableProps {
  printers: Printer[];
  isLoading?: boolean;
}

export const PrintersTable: React.FC<PrintersTableProps> = ({printers, isLoading}) => {
  const columns = [
    {
      header: 'Serial Number',
      accessorKey: 'printer_serial_no',
    },
    {
      header: 'Model',
      accessorKey: 'printer_type',
      Cell: ({cell}) => <PrinterType printer={cell.getValue()} />,
    },
    {
      header: 'Installation',
      accessorKey: 'installation_date',
      Cell: ({cell}) => <Moment format="DD-MM-YYYY">{cell.getValue()}</Moment>,
    },
    {
      header: 'Printer Status',
      accessorKey: 'guarantee_state',
      Cell: ({cell}) =>
        cell.getValue() === 1 ? <Badge pill variant="success" className="badge-soft-success">In guarantee</Badge> : <Badge pill variant="danger" className="badge-soft-danger">Not in guarantee</Badge>,
    },
    {
      header: 'Actions',
      accessorKey: 'actions',
      Cell: ({cell}) => {
        const printer: Printer = cell.row.original;
        return (
          <a href={'/printer/' + printer.id}>Open</a>
        );
      },
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={printers}
      enablePagination
      enableSorting
      enableBottomToolbar={false}
      initialState={{pagination: {pageSize: 10, pageIndex: 0}}}
    />
  );
};
